export enum BackupMethodOptions {
    backupCodes = 'backupCodes',
    secretQuestions = 'secretQuestions',
    backupEmailAddress = 'backupEmailAddress',
}
